<script lang="ts">
  import { RotateCw, Smartphone } from "@lucide/svelte";
</script>

<aside class="portrait-guard" role="status" aria-live="polite">
  <span class="portrait-device" aria-hidden="true"><Smartphone size={26} /><RotateCw class="portrait-rotate" size={14} /></span>
  <strong>Portrait view</strong>
  <span>Rotate your device to continue.</span>
</aside>
